// extracted by mini-css-extract-plugin
export var dividerLine = "_4n-0";
export var errorBackground = "_4n-1";